import { Heading, Paragraph } from '@zillow/constellation-10';
import type { Answers } from '../../../../models/rental-application';
import { isRequiredSection } from '../../../../hooks/useRequiredDocumentSections';

export function RequiredDocumentsStep() {
  return (
    <>
      <Heading level={2} textStyle="heading-sm" css={{ marginBottom: 'default', fontFamily: 'heading-alt' }}>
        Income documents
      </Heading>
      <Paragraph>The rental manager asked for these documents to support your application.</Paragraph>
    </>
  );
}

export const RequiredDocumentsRecommendation = {
  condition: ({ answers }: { answers: Answers }) =>
    (answers?.requiredDocuments ?? [])
      .filter(isRequiredSection)
      .some((section) => (section.documents ?? []).length === 0),
  title: 'Income documents',
  body: (
    <Paragraph>
      The rental manager asked for documents that your application is still missing. You can submit without them, but
      adding them helps the rental manager decide faster.
    </Paragraph>
  ),
};
